import useCreatePurchaseOrder from "api/OrderResource/useCreatePurchaseOrder";
import { ButtonLoader } from "components";
import Paypal from "components/Paypal";
import { activeCurrencies } from "utils";
import { FaPaypal } from "react-icons/fa";
import { FiLock, FiShield, FiExternalLink } from "react-icons/fi";

const PayPalPayment = ({ grandTotal, books, setPaymentIsSuccessful, addressId }) => {
	const { mutateAsync, isLoading } = useCreatePurchaseOrder();

	const _onPaypalComplete = async (order) => {
		const reference = order ? order?.id + "-" + order?.payer?.payer_id : Date.now();
		await mutateAsync({
			street_address: order?.purchase_units[0]?.shipping?.address?.address_line_1,
			city: order?.purchase_units[0]?.shipping?.address?.admin_area_2,
			province: order?.purchase_units[0]?.shipping?.address?.admin_area_1,
			country: order?.purchase_units[0]?.shipping?.address?.country_code,
			postcode: order?.purchase_units[0]?.shipping?.address?.postal_code,
			payment_method: "PayPal",
			payment_type: "Purchase",
			subtotal: 0,
			grand_charges: 0,
			books: books,
			grand_total: grandTotal,
			grand_total_zwl: 0,
			reference: reference,
			status: order?.status === "COMPLETED" ? "Completed" : "Failed",
			initiated_from: "cart",
			currency: activeCurrencies.USD.code,
			total_amount: grandTotal,
			address_id: addressId,
		});
		setPaymentIsSuccessful(true);
	};

	return (
		<div>
			{isLoading ? (
				<div className="flex flex-col gap-4 items-center justify-center py-8">
					<div className="w-16 h-16 rounded-full bg-akgreen/10 flex items-center justify-center">
						<ButtonLoader size={40} />
					</div>
					<div className="text-center">
						<p className="font-medium text-gray-900">Processing your payment...</p>
						<p className="text-sm text-gray-500 mt-1">Please wait while we confirm your order</p>
					</div>
				</div>
			) : (
				<div className="space-y-4">
					{/* PayPal Header */}
					<div className="flex items-center gap-3 pb-3 border-b border-gray-100">
						<div className="w-10 h-10 rounded-lg bg-akgreen/10 flex items-center justify-center">
							<FaPaypal className="w-5 h-5 text-akgreen" />
						</div>
						<div>
							<p className="font-semibold text-gray-900">PayPal Payment</p>
							<p className="text-sm text-gray-500">
								Amount:{" "}
								<span className="font-bold text-akgreener">${grandTotal.toFixed(2)} USD</span>
							</p>
						</div>
					</div>

					{/* How it works */}
					<div className="bg-akgreen/5 border border-akgreen/20 rounded-lg p-3 mb-4">
						<div className="flex items-start gap-2">
							<FiExternalLink className="w-5 h-5 text-akgreen flex-shrink-0 mt-0.5" />
							<div className="text-sm text-gray-700">
								<p className="font-medium mb-1">How it works:</p>
								<ol className="list-decimal list-inside space-y-1 text-gray-600">
									<li>Click the PayPal button below</li>
									<li>Log in to your PayPal account on the secure PayPal page</li>
									<li>Complete payment on PayPal's secure site</li>
								</ol>
							</div>
						</div>
					</div>

					{/* PayPal Button */}
					<div className="pt-2">
						<Paypal
							_onComplete={(order) => _onPaypalComplete(order)}
							amount={grandTotal}
							items={books}
						/>
					</div>

					{/* Trust Indicators */}
					<div className="flex items-center justify-center gap-4 pt-2 border-t border-gray-100">
						<div className="flex items-center gap-1.5 text-xs text-gray-500">
							<FiShield className="w-3.5 h-3.5 text-green-500" />
							<span>Buyer Protection</span>
						</div>
						<div className="flex items-center gap-1.5 text-xs text-gray-500">
							<FiLock className="w-3.5 h-3.5 text-green-500" />
							<span>Secure Payment</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default PayPalPayment;
